export const renewableEnergyIndustry = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Renewable Energy Industry - Boldare',
  url: 'https://www.boldare.com/renewable-energy-industry/',
  description:
    'Boldare partners with energy companies to build software platforms that optimize buying and selling energy, improve ROI, and accelerate product time-to-market.',
  publisher: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com',
  },
  mainEntity: {
    '@type': 'CreativeWork',
    name: 'Digital Transformation for sonnen',
    description:
      'Boldare supported sonnen in their digital transformation by developing an app for green energy charging.',
  },
  subjectOf: {
    '@type': 'Event',
    name: 'Practical AI for Renewable Energy Companies Webinar',
    description:
      'A webinar showcasing AI solutions to optimize renewable energy operations.',
  },
};
